module.exports = __webpack_public_path__ + "static/cover-02-6332f4a79f7e726957b22d1f5eb215ab.jpg";